import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { APP_NAME } from './config/app';

// Firebase is initialized via the services/firebase.ts import inside App
// Anonymous auth is triggered by the useAuth hook on first render

document.title = APP_NAME;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
